import { z } from 'zod';
import { BaseEntitySchema } from './common';
import { GameDefinitionId, ImageId, UserId } from './ids';
import { TeamScoringTypeSchema } from './team';

export const WinConditionSchema = z.enum(['mostPoints', 'mostRounds']);
export type WinCondition = z.infer<typeof WinConditionSchema>;

// Helper schema for optional positive numbers that handles NaN from empty inputs
// Accepts NaN from empty number inputs and transforms to undefined
const optionalPositiveNumber = z
  .union([z.number().int().positive(), z.nan()])
  .transform((val): number | undefined => {
    // Convert NaN to undefined, otherwise return the number
    if (Number.isNaN(val)) {
      return undefined;
    }
    return val;
  })
  .optional();

export const GameDefinitionSchema = BaseEntitySchema.extend({
  id: GameDefinitionId,
  name: z.string().min(1).max(100),
  description: z.string().max(500).optional(),
  hasRounds: z.boolean(),
  winCondition: WinConditionSchema,
  roundTargetPoints: optionalPositiveNumber,
  gameTargetPoints: optionalPositiveNumber,
  targetRounds: optionalPositiveNumber,
  teamScoringType: TeamScoringTypeSchema.optional(), // null = no teams, present = has teams
  imageId: ImageId.optional(),
  version: z.number().int().positive().default(1),
  userId: UserId.optional(), // Optional: game definitions can be created without authentication
});
export type GameDefinition = z.infer<typeof GameDefinitionSchema>;
